export type ResetCycle = 'YEARLY' | 'MONTHLY' | 'NEVER'

export type DocumentType = 'CONTRACT' | 'INVOICE' | 'ANNEX' | 'OFFER'

export type NumberingScheme = {
  code: string
  label: string
  pattern: string
  counterStart: number
  currentCounter: number
  resetCycle: ResetCycle
  lastResetAt: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export type NumberingSchemeAssignment = {
  id: number
  documentType: DocumentType
  configurationCode: string | null
  schemeCode: string
  createdAt: string
}

export type CreateNumberingSchemeRequest = {
  code: string
  label: string
  pattern: string
  counterStart: number
  resetCycle: ResetCycle
}

export type UpdateNumberingSchemeRequest = {
  label: string
  pattern: string
  counterStart: number
  resetCycle: ResetCycle
  isActive: boolean
}

export type CreateAssignmentRequest = {
  documentType: DocumentType
  configurationCode: string | null
  schemeCode: string
}

export const RESET_CYCLE_LABELS: Record<ResetCycle, string> = {
  YEARLY: 'Roczny',
  MONTHLY: 'Miesięczny',
  NEVER: 'Nigdy',
}

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  CONTRACT: 'Umowa',
  INVOICE: 'Faktura',
  ANNEX: 'Aneks',
  OFFER: 'Oferta',
}
